import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import isUuid from 'is-uuid';
import { ErrorLayout, PageContext } from '@axiom/ui';

export type UnauthorizedPageProps = {
  name?: string;
};

export const UnauthorizedPage = ({
  name = 'UNAUTHORIZED_PAGE',
}: UnauthorizedPageProps) => {
  const { setTitle } = useContext(PageContext);
  const { candidateId: urlCandidateId } = useParams();
  const homeUrl =
    urlCandidateId && isUuid.anyNonNil(urlCandidateId)
      ? `/talent/${urlCandidateId}/profile`
      : '/talent/profile';

  useEffect(() => {
    setTitle('Unauthorized');
  }, []);

  return (
    <div data-test={name}>
      <ErrorLayout
        errorMessage="You are not authorized to view this page."
        homeUrl={homeUrl}
      />
    </div>
  );
};
